webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(11)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(18),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Login__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Signup__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Signup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Signup__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Login: __WEBPACK_IMPORTED_MODULE_0__components_Login___default.a,
    Signup: __WEBPACK_IMPORTED_MODULE_1__components_Signup___default.a
  },
  data: function data() {
    return {
      display: false,
      view: '',
      transition: 'slide-right'
    };
  },

  created: function created() {
    var _this = this;

    setTimeout(function () {
      _this.display = true;
    }, 100);
    setTimeout(function () {
      _this.view = 'login';
    }, 400);
  },
  methods: {
    displaySignupForm: function displaySignupForm() {
      this.view = 'signup';
      this.transition = 'slide-left';
    },
    hideSignupForm: function hideSignupForm() {
      this.view = 'login';
      this.transition = 'slide-right';
    }
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_focus__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  directives: {
    focus: __WEBPACK_IMPORTED_MODULE_0_vue_focus__["focus"]
  },
  data: function data() {
    return {
      focused: true,
      username: '',
      password: ''
    };
  },

  methods: {
    signup: function signup() {
      this.$emit('signup');
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_focus__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  directives: {
    focus: __WEBPACK_IMPORTED_MODULE_0_vue_focus__["focus"]
  },
  data: function data() {
    return {
      focused: true,
      email: '',
      name: '',
      password: '',
      passwordConfirmation: ''
    };
  },

  methods: {
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
});

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(13)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(20),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(12)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(19),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.display) ? _c('div', {
    staticClass: "box shadow"
  }, [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "out-in"
    }
  }, [_c(_vm.view, {
    tag: "component",
    on: {
      "cancel": _vm.hideSignupForm,
      "signup": _vm.displaySignupForm
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signup-container"
  }, [_c('a', {
    staticClass: "login-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancel($event)
      }
    }
  }, [_vm._v("Already have an account?")]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Daily UI")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Welcome!")]), _vm._v(" "), _c('form', {
    staticClass: "signup-form"
  }, [_c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "fa fa-user-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "focus",
      rawName: "v-focus",
      value: (_vm.focused),
      expression: "focused"
    }],
    staticClass: "username",
    attrs: {
      "type": "text",
      "placeholder": "Full Name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "focus": function($event) {
        _vm.focused = true
      },
      "blur": function($event) {
        _vm.focused = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "join-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("SIGN UP")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "email",
    attrs: {
      "type": "email",
      "placeholder": "E-mail Address"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "password",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    }
  })])
}]}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_c('a', {
    staticClass: "signup-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signup($event)
      }
    }
  }, [_vm._v("You don't have an account?")]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Daily UI")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Welcome back!")]), _vm._v(" "), _c('form', {
    staticClass: "login-form"
  }, [_c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.focused),
      expression: "focused"
    }],
    staticClass: "email",
    attrs: {
      "type": "email",
      "placeholder": "E-mail Address"
    },
    on: {
      "focus": function($event) {
        _vm.focused = true
      },
      "blur": function($event) {
        _vm.focused = false
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "login-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("SIGN IN")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "password",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    }
  })])
}]}

/***/ })
],[5]);


// WEBPACK FOOTER //
// static/js/app.2029141917a74e742c8b.js